import { createSelector } from 'reselect';

const selectState = (state) => state.get('dialogSendOffer');

const makeSelectAppointmentTypes = () => createSelector(selectState, (state) => state.get('appointmentTypes'));

const makeSelectFacilities = () => createSelector(selectState, (state) => state.get('facilities'));

const makeSelectLoading = () => createSelector(selectState, (state) => state.get('loading'));

const makeSelectPatients = () => createSelector(selectState, (state) => state.get('patients'));

const makeSelectProviders = () => createSelector(selectState, (state) => state.get('providers'));

const makeSelectTags = () => createSelector(selectState, (state) => state.get('tags'));

const makeSelectWaitlists = () => createSelector(selectState, (state) => state.get('waitlists'));

const makeSelectWaitlistsGlobalCount = () => createSelector(selectState, (state) => state.get('waitlistsGlobalCount'));

const makeSelectIsBullkWaitlists = () => createSelector(selectState, (state) => state.get('isBulkWaitlists'));

const makeSelectWaitlistsQueryId = () => createSelector(selectState, (state) => state.get('waitlistsQueryId'));

export {
  makeSelectAppointmentTypes,
  makeSelectFacilities,
  makeSelectLoading,
  makeSelectPatients,
  makeSelectProviders,
  makeSelectTags,
  makeSelectWaitlists,
  makeSelectWaitlistsGlobalCount,
  makeSelectIsBullkWaitlists,
  makeSelectWaitlistsQueryId,
  selectState,
};
